import { EyeOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Box, Text } from 'atoms';
import { StatusAction } from 'components';
import EmployeeStatusAction from 'components/status-action/EmployeeStatusAction';
import { ACL } from 'components/common';
import { getLocalDate, getLocalTime } from 'utils/helpers';
import { getUIVersion } from 'utils/router-static-data';

export const UserManagementTableConfig = [
	{
		title: 'Username',
		dataIndex: 'username',
		key: 'username',
		hidden: false,
		render: (username) => <Text overFlow="hidden">{username || ''}</Text>,
	},
	{
		title: 'First Name',
		dataIndex: 'first_name',
		key: 'first_name',
		hidden: false,
		render: (first_name) => <Text overFlow="hidden">{first_name || ''}</Text>,
	},
	{
		title: 'Last Name',
		dataIndex: 'last_name',
		key: 'last_name',
		hidden: false,
		render: (last_name) => <Text overFlow="hidden">{last_name || ''}</Text>,
	},
	{
		title: 'Email',
		dataIndex: 'email',
		key: 'email',
		hidden: false,
		render: (email) => <Text overFlow="hidden">{email || ''}</Text>,
	},
	{
		title: 'Mobile',
		dataIndex: 'mobile_number',
		key: 'mobile_number',
		hidden: false,
		render: (mobile_number) => <Text overFlow="hidden">{mobile_number || ''}</Text>,
	},
	{
		title: 'User Type',
		dataIndex: 'user_type',
		key: 'user_type',
		hidden: false,
		render: (user_type) => <Text overFlow="hidden">{user_type || ''}</Text>,
	},
	{
		title: 'Created at',
		dataIndex: 'created_at',
		key: 'created_at',
		render: (created_at) => (
			<Box>
				<Text overFlow="hidden">{getLocalDate(created_at)}</Text>

				<Text overFlow="hidden" fontStyle="italic">
					{getLocalTime(created_at)}
				</Text>
			</Box>
		),
	},
	{
		title: 'View',
		dataIndex: 'id',
		key: 'id',
		hidden: false,
		render: (id) => (
			<Link to={`/employees/${id}`}>
				<EyeOutlined />
			</Link>
		),
	},
	{
		title: 'Action',
		dataIndex: 'id',
		key: 'id',
		hidden: false,
		render: (id, record) => {
			const uiVersion = getUIVersion();
			const useV2API = uiVersion === 'new';

			return (
				<ACL action="update" module="employee">
					{useV2API ? (
						<EmployeeStatusAction statusData={record?.is_active} id={id} />
					) : (
						<StatusAction statusData={record?.is_active} userType="employee" id={id} />
					)}
				</ACL>
			);
		},
	},
];
